import Cookies from '@arsenal/arsenal/modules/Cookies'
import CarList from 'Components/series/car-list'
import Favour from 'Components/series/favour'
import Leaderboard, { IItemInfo } from 'Components/series/leaderboard'
import React, { useEffect, useMemo, useState } from 'react'
import Popup from '../article/popup'
import { stringify } from 'querystring'
import ScrollLoader from 'Components/scroll-loader'
import { IFeedData } from 'lib/fetch-community-feed'
import fetch from 'lib/decorated-fetch'
import VideoCard from './video-card'
import Loading from 'Components/loading'
import { sendTeaCommEvent } from 'lib/tea-analyze'
const empty_icon = require('static/empty-envelope.png')

interface IVideo {
  rankData: IItemInfo[]
  seriesId: number
}

export default function Video(props: IVideo) {
  const { rankData, seriesId } = props
  const [activeTab, setActiveTab] = useState('recommended')
  const menu = useMemo(
    () => [
      {
        value: 'recommended',
        text: '推荐视频',
      },
      {
        value: 'latest',
        text: '最新视频',
      },
    ],
    []
  )
  const handleChange = ({ value, text }: { value: string; text: string }) => {
    sendTeaCommEvent('click_video_type_select', {
      obj_text: text,
      car_series_id: seriesId,
    })
    setActiveTab(value)
  }

  const [videos, setVideos] = useState<IFeedData[]>([])
  const [loading, setLoading] = useState(false)
  const [max_behot_time, setMaxBeHotTime] = useState(0)
  const fetchVideos = async (maxBehotTime: number) => {
    let newVideos = []
    const web_id: any = Cookies('tt_webid') || ''
    try {
      const params = {
        concern_id: seriesId,
        category: 'video',
        web_id,
        device_platform: 'web',
        channel: 'web',
        tt_from: 'enter_auto',
        motor_feed_extra_params: JSON.stringify({
          new_feed: true,
          series_page_sort: activeTab,
        }),
        sub_category: 'video',
        impression_info: JSON.stringify({
          page_id: 'page_car_series',
          sub_tab: 'video',
        }),
        max_behot_time: maxBehotTime,
        aid: 1839,
      }
      const json = await fetch(
        `/motor/stream_entrance/get_feed_pc/v47/?${stringify(params)}`
      ).catch((e) => {
        // no-op
      })
      newVideos = json?.data || []
      setMaxBeHotTime(
        newVideos?.[newVideos.length - 1]?.info?.behot_time || maxBehotTime
      )
    } catch (err) {
      // no-op
    }
    if (maxBehotTime > 0) {
      setVideos([...videos, ...newVideos])
    } else {
      setVideos([...newVideos])
    }
  }

  useEffect(() => {
    setVideos([])
    setLoading(true)
    fetchVideos(0).finally(() => {
      setLoading(false)
    })
  }, [activeTab])

  const loadMoreHandler = async () => {
    setLoading(true)
    await fetchVideos(max_behot_time)
    setLoading(false)
  }

  return (
    <React.Fragment>
      <div className="content-wrapper">
        <section className="left-part">
          <Popup
            menu={menu}
            active={activeTab}
            onChange={handleChange}
            className="pop-up"
          />
          {videos.length > 0 ? (
            <>
              <ScrollLoader
                end={false}
                loading={loading}
                loadMoreHandler={loadMoreHandler}
              >
                <div className="videos">
                  {videos.map((video, index) => {
                    return (
                      <VideoCard
                        key={video.unique_id_str}
                        data={video}
                        className="video-card"
                        onClick={() => {
                          sendTeaCommEvent('click_series_video_list_item', {
                            car_series_id: seriesId,
                            group_id: video.unique_id_str,
                            article_type: menu.find(
                              (item) => item.value === activeTab
                            )?.value,
                          })
                        }}
                      />
                    )
                  })}
                </div>
              </ScrollLoader>
              {loading && <Loading />}
            </>
          ) : (
            <span className="no-article">
              <img src={empty_icon} />
              暂无视频
            </span>
          )}
        </section>
        <section className="right-part">
          <Leaderboard
            type="video"
            data={rankData}
            className="margin-bottom-8"
            seriesId={seriesId}
          />
          <Favour className="margin-bottom-8" />
          <CarList series_id={seriesId} className="margin-bottom-8" />
        </section>
      </div>
      <style jsx>
        {`
          .content-wrapper {
            display: flex;
            width: 1196px;
            margin: 8px auto 0;
          }
          .left-part {
            width: 868px;
            min-height: 630px;
            margin-right: 8px;
            position: relative;
          }
          :global(.pop-up) {
            margin-bottom: 16px;
            margin-top: 16px;
            margin-left: 16px;
          }
          .videos {
            display: flex;
            flex-wrap: wrap;
          }
          :global(.video-card) {
            margin-right: 12px;
            margin-bottom: 32px;
          }
          :global(.video-card:nth-child(3n)) {
            margin-right: 0;
          }
          .right-part {
            width: 320px;
          }
          :global(.margin-bottom-8) {
            margin-bottom: 8px;
          }
          .no-article {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            color: #606370;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
          }
          .no-article > img {
            width: 80px;
            height: 80px;
            object-fit: cover;
            object-position: center;
          }
        `}
      </style>
    </React.Fragment>
  )
}
